export default __webpack_public_path__ + "static/media/img_services03.1358045f.png";